'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.div.withConfig({
  componentId: 's1fyhgmv-0'
})(['font-family:', ';max-width:', ';color:', ';margin:', ';'], function (p) {
  return p.theme.primaryFont;
}, function (p) {
  return p.theme.formMaxWidth;
}, function (p) {
  return p.theme.baseColor;
}, function (p) {
  return p.theme.formMargin;
});